import { useQuery } from '@tanstack/react-query';
import { vehicleOptions } from '../../constants/vehicles';
export function useVehicle(id, scope) {
    const { data, isLoading, isSuccess } = useQuery(vehicleOptions.get({ id }, scope));
    return {
        vehicle: data?.find((vehicle) => vehicle.id === id),
        loadingVehicle: isLoading,
        isSuccess,
    };
}
